import { createStyles, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import {
  colorSectionHeadingOnLight,
  elevatedSurfaceBoxShadow,
  layoutContentMaxWidthPx,
  transition,
} from '../../../../shared/style-settings'

export const useMainPageSustainabilitySectionStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        backgroundColor: '#f6faf7',
        borderTop: `1px solid ${theme.palette.grey[200]}`,
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
        paddingTop: theme.spacing(10),
        paddingBottom: theme.spacing(10),
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        [theme.breakpoints.down('sm')]: {
          paddingTop: theme.spacing(8),
          paddingBottom: theme.spacing(8),
          paddingLeft: theme.spacing(2.5),
          paddingRight: theme.spacing(2.5),
        },
      },
      inner: {
        maxWidth: layoutContentMaxWidthPx,
        margin: '0 auto',
      },
      imageFrame: {
        borderRadius: 18,
        overflow: 'hidden',
        boxShadow: elevatedSurfaceBoxShadow,
        position: 'relative',
        backgroundColor: theme.palette.grey[200],
        transition,
        '&:hover': {
          boxShadow: '0 16px 44px rgba(30, 50, 250, 0.11)',
        },
      },
      image: {
        display: 'block',
        width: '100%',
        height: 'auto',
        objectFit: 'cover',
        aspectRatio: '4 / 3',
        minHeight: 200,
        [theme.breakpoints.down('md')]: {
          maxHeight: 360,
        },
      },
      title: {
        margin: 0,
        marginBottom: theme.spacing(2),
        fontWeight: 700,
        fontSize: 'clamp(1.5rem, 2.2vw, 2.125rem)',
        color: colorSectionHeadingOnLight,
        letterSpacing: '-0.02em',
        lineHeight: 1.25,
      },
      lead: {
        margin: 0,
        marginBottom: theme.spacing(3),
        fontSize: 'clamp(0.9375rem, 1.25vw, 1.0625rem)',
        lineHeight: 1.7,
        color: theme.palette.text.primary,
        fontWeight: 500,
        maxWidth: 560,
      },
      list: {
        margin: 0,
        padding: 0,
        listStyle: 'none',
        maxWidth: 580,
      },
      listItem: {
        position: 'relative',
        paddingLeft: theme.spacing(3.25),
        marginBottom: theme.spacing(2),
        fontSize: 'clamp(0.875rem, 1.1vw, 1rem)',
        lineHeight: 1.62,
        color: theme.palette.text.secondary,
        fontWeight: 500,
        '&:last-child': {
          marginBottom: 0,
        },
        '&::before': {
          content: '""',
          position: 'absolute',
          left: 0,
          top: '0.45em',
          width: theme.spacing(1.25),
          height: theme.spacing(1.25),
          borderRadius: '50%',
          backgroundColor: theme.palette.primary.main,
          opacity: 0.9,
          boxShadow: `0 0 0 3px rgba(30, 50, 250, 0.15)`,
        },
      },
    })
)
